import axios from "axios";
import {apiUrl} from "@/main";
import router from "@/router";
import { SET_NOTIFICATION } from "@/store/constant";
import store from '@/store';

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (!error.response) {
    store.commit(SET_NOTIFICATION,{ type: 'error', messages: ['只今アクセスはできません。しばらくしてから再度試してください。'] });
  }
  if (error.response.status === 404) {
    router.replace({ name: 'not-found', });
  }
  return Promise.reject(error);
});

export const addRequestHeader = (name, token) => {
  axios.defaults.headers.common[name] = `Bearer ${token}`;
}

export const getImage = (item) => {
  const media = item.media;
  if (media) {
    if (media.formats && media.formats.large) {
      return `${apiUrl}${media.formats.large.url}`;
    } else {
      return `${apiUrl}${media.url}`;
    }
  }
  return '';
}

export const getDate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  let month = d.getMonth() + 1;
  let day = d.getDate();
  let hours = d.getHours();
  let minutes = d.getMinutes();
  if (month < 10) {
    month = `0${month}`
  }
  if (day < 10) {
    day = `0${day}`
  }
  if (hours < 10) {
    hours = `0${hours}`
  }
  if (minutes < 10) {
    minutes = `0${minutes}`
  }
  return `${year}年${month}月${day}日${hours}:${minutes}`;
}

export const getPrefectures = () => {
  return ['北海道', '青森', '岩手', '宮城', '秋田', '山形', '福島', '茨城', '栃木', '群馬', '埼玉', '千葉', '東京', '神奈川', '新潟', '富山', '石川', '福井', '山梨', '長野', '岐阜', '静岡', '愛知',
    '三重', '滋賀', '京都', '大阪', '兵庫', '奈良', '和歌山', '鳥取', '島根', '岡山', '広島', '山口', '徳島', '香川', '愛媛', '高知', '福岡', '佐賀', '長崎', '熊本', '大分', '宮崎', '鹿児島', '沖縄'];
}

export const splitLocationText = (location) => {
  if (!location || !location.includes('【'))
    return null;

  const prefecture = location.split('【')[1].split('】')[0];
  const freeLocationText = location.replace(`【${prefecture}】`, '');
  return { prefecture, freeLocationText };
};

export const setToken = (token) => {
  localStorage.setItem('user-token', token);
  addRequestHeader('Authorization', token);
}
